import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { PickerComputer } from './picker-computer/PickerComputer';
import { PickerGoogle } from './picker-google/PickerGoogle';
import { PickerSmartphone } from './picker-smartphone/PickerSmartphone';
import { PickerFamilyFriends } from './picker-family-friends/PickerFamilyFriends';
import { PickerProps, WrapperPickerProps } from './Picker.types';

const EmptyPicker = () => <></>;

const PICKER_MAPS: Record<SELECTED_MENU_ITEMS, React.ComponentType<PickerProps>> = {
  [SELECTED_MENU_ITEMS.Computer]: PickerComputer,
  [SELECTED_MENU_ITEMS.Gallery]: PickerComputer,
  [SELECTED_MENU_ITEMS.GooglePhoto]: PickerGoogle,
  [SELECTED_MENU_ITEMS.Smartphone]: PickerSmartphone,
  [SELECTED_MENU_ITEMS.FamilyFriends]: PickerFamilyFriends,
  [SELECTED_MENU_ITEMS.Add]: EmptyPicker,
};

export const Picker = ({ source, ...props }: WrapperPickerProps) => {
  const Picker = PICKER_MAPS[source] ?? EmptyPicker;
  return <Picker {...props} />;
};
